'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DashboardItem = require('./DashboardItem');

var _DashboardItem2 = _interopRequireDefault(_DashboardItem);

var _DashboardGroup = require('./DashboardGroup');

var _DashboardGroup2 = _interopRequireDefault(_DashboardGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboard = function (_React$Component) {
  (0, _inherits3.default)(Dashboard, _React$Component);

  function Dashboard() {
    (0, _classCallCheck3.default)(this, Dashboard);
    return (0, _possibleConstructorReturn3.default)(this, (Dashboard.__proto__ || (0, _getPrototypeOf2.default)(Dashboard)).apply(this, arguments));
  }

  (0, _createClass3.default)(Dashboard, [{
    key: 'renderGapMark',
    value: function renderGapMark(rowNumber, colNumber, isLastRow, isLastCol, nolt, norb) {
      var arr = [];

      !nolt && arr.push(_react2.default.createElement('i', { className: 'cn-dash-board-gap-mark cn-dash-board-gap-mark-lt', key: 'gap-mark-lt' }));
      !norb && arr.push(_react2.default.createElement('i', { className: 'cn-dash-board-gap-mark cn-dash-board-gap-mark-rb', key: 'gap-mark-rb' }));

      (rowNumber === 0 || isLastCol) && arr.push(_react2.default.createElement('i', { className: 'cn-dash-board-gap-mark cn-dash-board-gap-mark-rt', key: 'gap-mark-rt' }));
      (isLastRow || colNumber === 0) && arr.push(_react2.default.createElement('i', { className: 'cn-dash-board-gap-mark cn-dash-board-gap-mark-lb', key: 'gap-mark-lb' }));
      return arr;
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(e) {
      e.stopPropagation();
      var tar = e.currentTarget;
      var left = -(e.clientX - this.getLeft(tar) - tar.offsetWidth / 2) / (tar.offsetWidth / 2);
      var top = -(e.clientY + document.documentElement.scrollTop - this.getTop(tar) - tar.offsetHeight / 2) / (tar.offsetHeight / 2);
      tar.style['box-shadow'] = left * this.props.shadowSkewingSize + 'px ' + top * this.props.shadowSkewingSize + ('px ' + this.props.shadowSize + 'px 0 rgba(0,0,0,0.1)');
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave(e) {
      e.stopPropagation();
      var tar = e.currentTarget;
      tar.style['box-shadow'] = '0 0 0 0 rgba(0,0,0,0.15)';
    }
  }, {
    key: 'getArray',
    value: function getArray(list) {
      if (!list) {
        return null;
      }
      if (!list.length) {
        return [list];
      } else {
        return list;
      }
    }
  }, {
    key: 'getTop',
    value: function getTop(tar) {
      var offset = tar.offsetTop;
      if (tar.offsetParent != null) offset += this.getTop.call(this, tar.offsetParent);
      return offset;
    }
  }, {
    key: 'getLeft',
    value: function getLeft(tar) {
      var offset = tar.offsetLeft;
      if (tar.offsetParent != null) offset += this.getLeft.call(this, tar.offsetParent);
      return offset;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          column = _props.column,
          type = _props.type,
          contentPadding = _props.contentPadding,
          shadowSkewingSize = _props.shadowSkewingSize,
          shadowSize = _props.shadowSize,
          showGapMark = _props.showGapMark,
          showGapLine = _props.showGapLine,
          itemMinWidth = _props.itemMinWidth,
          className = _props.className,
          others = (0, _objectWithoutProperties3.default)(_props, ['column', 'type', 'contentPadding', 'shadowSkewingSize', 'shadowSize', 'showGapMark', 'showGapLine', 'itemMinWidth', 'className']);
      var children = this.props.children;

      var itemWidth = 100 / column + '%';
      if (!children.length) {
        children = [children];
      }

      var padding = [];

      if (contentPadding.length === 1) {
        padding = [contentPadding[0], contentPadding[0], contentPadding[0], contentPadding[0]];
      } else if (contentPadding.length === 2) {
        padding = [contentPadding[0], contentPadding[1], contentPadding[0], contentPadding[1]];
      } else if (contentPadding.length === 3) {
        padding = [contentPadding[0], contentPadding[1], contentPadding[2], contentPadding[1]];
      } else {
        padding = [contentPadding[0], contentPadding[1], contentPadding[2], contentPadding[3]];
      }

      if (padding[0]) {
        var topGap = [padding[0]];
      }

      var colArr = new Array(column).toString().split(',');

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: 'cn-dash-board ' + ('cn-dash-board-' + type) + ' ' + (className || '') }, others),
        _react2.default.createElement(
          'div',
          { className: 'cn-dash-board-inner-content ' + (!showGapLine && 'no-border') },
          _react2.default.createElement(
            'div',
            { className: 'cn-dash-board-row cn-dash-gap-row' },
            _react2.default.createElement('div', { key: 'gap-t-first', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[3], height: padding[0], flex: '0 0 ' + padding[3] + 'px', minWidth: padding[3] } }),
            colArr.map(function (record, _id) {
              return _react2.default.createElement(
                'div',
                { key: 'gap-t' + _id, className: 'cn-dash-board-item cn-dash-board-item-gap', style: { flex: '1 1 auto', width: 'auto', minWidth: itemMinWidth, height: padding[0] } },
                showGapMark && padding[0] ? _this2.renderGapMark.call(_this2, 1, 0, false, false, true) : null
              );
            }),
            _react2.default.createElement('div', { key: 'gap-t-last', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[1], height: padding[0], flex: '0 0 ' + padding[1] + 'px', minWidth: padding[1] } })
          ),
          children.map(function (record, _id) {
            return _react2.default.createElement(
              'div',
              { className: 'cn-dash-board-group ' + (record.props.className || ''), key: _id },
              record.props.title ? _react2.default.createElement(
                'div',
                { className: 'cn-dash-board-row cn-dash-board-row-title', key: _id + '_title' },
                _react2.default.createElement('div', { key: 'gap-l-first', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[3], flex: '0 0 ' + padding[3] + 'px', minWidth: padding[3] } }),
                _react2.default.createElement(
                  'div',
                  { className: 'cn-dash-board-item',
                    style: { flex: '1', minWidth: itemMinWidth }, key: _id + '-' + 1 },
                  _react2.default.createElement(
                    'div',
                    { className: 'cn-dash-board-item-inner' },
                    _react2.default.createElement(
                      'span',
                      { className: 'cn-dash-board-group-title' },
                      record.props.title
                    ),
                    showGapMark ? _this2.renderGapMark.call(_this2, _id, 0, false, true) : null
                  )
                ),
                _react2.default.createElement('div', { key: 'gap-r-first', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[1], flex: '0 0 ' + padding[1] + 'px', minWidth: padding[1] } })
              ) : null,
              record.props.children && new Array(Math.ceil(_this2.getArray.call(_this2, record.props.children).length / column)).toString().split(',').map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'cn-dash-board-row', style: { height: record.props.itemHeight || '' }, key: index },
                  _react2.default.createElement('div', { key: 'gap-l-first', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[3], flex: '0 0 ' + padding[3] + 'px', minWidth: padding[3] } }),
                  colArr.map(function (it, id) {
                    var child = _this2.getArray.call(_this2, record.props.children);

                    if (child[index * column + id] && child[index * column + id].props && child[index * column + id].props.href) {
                      return _react2.default.createElement(
                        'a',
                        { target: child[index * column + id] && child[index * column + id].props.target,
                          href: child[index * column + id] && child[index * column + id].props.href,
                          className: 'cn-dash-board-item ' + (child[index * column + id] && child[index * column + id].props && child[index * column + id].props.className || '') + (!child[index * column + id] ? 'no-content' : ''), onMouseLeave: child[index * column + id] && _this2.onMouseLeave.bind(_this2), onMouseMove: child[index * column + id] && _this2.onMouseMove.bind(_this2),
                          style: { flex: (record.props.columnFlex ? record.props.columnFlex[id] : '1') + " 0 21px", minWidth: itemMinWidth }, key: index + '-' + id },
                        _react2.default.createElement(
                          'div',
                          { className: 'cn-dash-board-item-inner' },
                          child[index * column + id],
                          showGapMark ? _this2.renderGapMark.call(_this2, index, id, index === new Array(Math.ceil(_this2.getArray.call(_this2, record.props.children).length / column)).toString().split(',').length - 1, id === colArr.length - 1) : null
                        )
                      );
                    } else {
                      return _react2.default.createElement(
                        'div',
                        {
                          className: 'cn-dash-board-item ' + (child[index * column + id] && child[index * column + id].props && child[index * column + id].props.className || '') + (!child[index * column + id] ? 'no-content' : ''), onMouseLeave: child[index * column + id] && _this2.onMouseLeave.bind(_this2), onMouseMove: child[index * column + id] && _this2.onMouseMove.bind(_this2),
                          style: { flex: (record.props.columnFlex ? record.props.columnFlex[id] : '1') + " 0 21px", minWidth: itemMinWidth }, key: index + '-' + id },
                        _react2.default.createElement(
                          'div',
                          { className: 'cn-dash-board-item-inner' },
                          child[index * column + id],
                          showGapMark ? _this2.renderGapMark.call(_this2, index, id, index === new Array(Math.ceil(_this2.getArray.call(_this2, record.props.children).length / column)).toString().split(',').length - 1, id === colArr.length - 1) : null
                        )
                      );
                    }
                  }),
                  _react2.default.createElement('div', { key: 'gap-r-first', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[1], flex: '0 0 ' + padding[1] + 'px', minWidth: padding[1] } })
                );
              })
            );
          }),
          _react2.default.createElement(
            'div',
            { className: 'cn-dash-board-row cn-dash-gap-row' },
            _react2.default.createElement('div', { key: 'gap-t-first', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[3], height: padding[2], flex: '0 0 ' + padding[3] + 'px', minWidth: padding[3] } }),
            colArr.map(function (record, _id) {
              return _react2.default.createElement('div', { key: 'gap-t' + _id, className: 'cn-dash-board-item cn-dash-board-item-gap', style: { flex: '1 1 auto', width: 'auto', minWidth: itemMinWidth, height: padding[2] } });
            }),
            _react2.default.createElement('div', { key: 'gap-t-last', className: 'cn-dash-board-item cn-dash-board-item-gap', style: { width: padding[1], height: padding[2], flex: '0 0 ' + padding[1] + 'px', minWidth: padding[1] } })
          )
        )
      );
    }
  }]);
  return Dashboard;
}(_react2.default.Component);

Dashboard.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'normal']),
  shadowSkewingSize: _propTypes2.default.number,
  shadowSize: _propTypes2.default.number,
  contentPadding: _propTypes2.default.array,
  showGapLine: _propTypes2.default.bool,
  showGapMark: _propTypes2.default.bool,
  column: _propTypes2.default.number,
  itemMinWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
Dashboard.defaultProps = {
  width: '100%',
  height: '100%',
  contentPadding: [48],
  showGapLine: true,
  showGapMark: true,
  column: 4,
  shadowSkewingSize: 20,
  shadowSize: 30,
  type: 'normal',
  itemMinWidth: 'auto'
};


Dashboard.Group = _DashboardGroup2.default;
Dashboard.Item = _DashboardItem2.default;

exports.default = Dashboard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-dashboard@0.0.23@@alicd/crui-dashboard/lib/index.js
// module id = 611
// module chunks = 0